import { IsVerbose } from './Console';
import { AcademyItem } from '../interfaces/AcademyItem';

export interface ImageOperation {
	language: string;
	action: 'upload' | 'delete';
	data?: string;
}

// Diff must be computed against savedItem: persisted images round-trip from the
// server as data: URLs, so the prefix alone cannot tell a new pick from a saved one.
export const getImageOperations = (editedItem: AcademyItem, savedItem: AcademyItem | null): ImageOperation[] => {
	const ops: ImageOperation[] = [];
	editedItem.Info.forEach((info) => {
		const savedImage = savedItem?.Info.find((saved) => saved.language === info.language)?.Image || '';
		const editedImage = info.Image || '';
		if (editedImage === savedImage) { return; }
		if (editedImage) {
			ops.push({ language: info.language, action: 'upload', data: editedImage });
		} else {
			ops.push({ language: info.language, action: 'delete' });
		}
	});
	return ops;
}

export const hasValues = (obj: any): boolean => {
	try {
		return Object.values(obj).some(v => v !== null && typeof v !== "undefined");
	} catch (error) {
		return false
	}
}

export function validateEmail(email: string): boolean {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

export function sortArray<T>(items: T[], sortKey: string, isSortedDescending?: boolean): T[] {
	const key = sortKey as keyof T;
	return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}

export const getTenantId = (token: string): string => {
	try {
		const claims = JSON.parse(atob(token.split('.')[1]));
		IsVerbose() && console.log(claims.tid)
		return claims.tid
	} catch (error) {
		return ''
	}
}

export const cloneObject = <T,>(obj: T): T => {
	return JSON.parse(JSON.stringify(obj));
}

export function getContrastColor(background: string): string {
	const rgb = parseColor(background);
	if (!rgb) return '#000000';
	const [r, g, b] = rgb.map(c => {
		const s = c / 255;
		return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
	});
	const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
	return luminance > 0.179 ? '#000000' : '#ffffff';
}

function parseColor(input: string): [number, number, number] | null {
	if (!input) return null;
	const value = input.trim();

	if (value.startsWith('#')) {
		let hex = value.slice(1);
		if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
		if (hex.length !== 6) return null;
		const num = parseInt(hex, 16);
		if (isNaN(num)) return null;
		return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
	}

	const match = value.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
	if (match) return [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3], 10)];

	return null;
}
